var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.componentName,{key:_vm.index,tag:"component",attrs:{"component-data":_vm.component_data},on:{"updated":function($event){return _vm.$emit('updated')}}})}
var staticRenderFns = []

export { render, staticRenderFns }